import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { logout } from "../Library/Utils";

export const useApiCall = () => {
  const { t } = useTranslation();

  const call = async (
    apiCall: () => Promise<any>,
    onSuccess: (data: any) => void,
    onError?: (err?: any) => void
  ) => {
    try {
      const res = await apiCall();
      const { data, status, statusText } = res;
      if (status >= 200 && status < 300) {
        onSuccess(data);
      } else {
        switch (status) {
          case 400:
            toast.error(data[Object.keys(data)[0]]);
            if (onError) onError(data);
            break;
          case 401:
            if (onError) onError(data);
            toast.error(t("Translation.credential_not_provided"));
            logout();
            break;
          default:
            toast.error(
              statusText || t("Translation.error_something_went_wrong")
            );
            console.log("DEFAULT ERROR ================= ")
            if (onError) onError(data);
            break;
        }
      }
    } catch (err: any) {
      // Only show toast if this is a network error or if no response status exists
      if (!err?.response?.status) {
        console.log("CATCH BLOCK ================= ", Math.random())
        console.log(err, "err");
        toast.error(t("Translation.error_something_went_wrong"));
      }
      if (onError) onError(err);
    }
  };

  const recursivePaginatedCall = async (
    apiCall: (page: number) => Promise<any>,
    page = 1,
    prevResponse = []
  ): Promise<any> => {
    const response: any = [...prevResponse];
    const res = await apiCall(page);
    response.push(res.data.results);
    if (res.data.next) {
      return recursivePaginatedCall(apiCall, page + 1, response);
    } else {
      return {
        ...res,
        data: {
          ...res.data,
          results: response.flat(),
        },
      };
    }
  };

  return { call, recursivePaginatedCall };
};
